/* global mainScript */
import React, { useEffect, useRef } from "react";
import { motion } from "framer-motion";
import styled from "@emotion/styled";
import PropTypes from "prop-types";

//style rules
import { Typography, Sizes } from "../../styles";
import DropDown from "./DropDown";

const FiltersPanel = ({
	toggleFiltersPanel,
	filters,
	handleFilterSelect,
	selectedFilters,
	clearFilters,
}) => {
	const ref = useRef(null);

	const handleOutsidePanelClick = (e) => {
		if (ref.current && !ref.current.contains(e.target)) {
			toggleFiltersPanel();
		}
	};

	useEffect(() => {
		document.addEventListener("mousedown", handleOutsidePanelClick);
		return () => {
			document.removeEventListener("mousedown", handleOutsidePanelClick);
		};
	}, []);

	const renderDropDowns =
		filters &&
		Object.entries(filters).map((filter) => {
			const [key, value] = filter;
			if (value.some((v) => v.name && v.slug)) {
				return (
					<DropDown
						key={key}
						DropDownLabel={key == "types" ? "Experience type" : "Locations"}
						filters={value}
						toggleFiltersPanel={toggleFiltersPanel}
						handleFilterSelect={handleFilterSelect}
						selectedFilters={selectedFilters}
					/>
				);
			}
		});

	return (
		<Panel ref={ref} layoutId="expandable-panel">
			<CloseButton
				onClick={toggleFiltersPanel}
				src={mainScript.assetPath + "images/svg/icons/icon-close.svg"}
			/>
			<PanelTitle
				transition={{ delay: 0.5 }}
				initial={{ opacity: 0 }}
				animate={{ opacity: 1 }}
				exit={{ opacity: 0 }}
			>
				Filter Events
			</PanelTitle>
			<FlexContainer
				transition={{ delay: 0.5 }}
				initial={{ opacity: 0 }}
				animate={{ opacity: 1 }}
				exit={{ opacity: 0 }}
			>
				<ItemsWrapper>{renderDropDowns}</ItemsWrapper>
				<ItemsWrapper>
					<SelectFiltersButton onClick={() => toggleFiltersPanel()}>
						Apply Filters
					</SelectFiltersButton>
					<ClearFiltersButton onClick={() => clearFilters()}>
						Clear
					</ClearFiltersButton>
				</ItemsWrapper>
			</FlexContainer>
		</Panel>
	);
};

export default FiltersPanel;

FiltersPanel.propTypes = {
	toggleFiltersPanel: PropTypes.func,
	filters: PropTypes.object,
	handleFilterSelect: PropTypes.func,
	selectedFilters: PropTypes.array,
	clearFilters: PropTypes.func,
};

const Panel = styled(motion.div)`
	padding: 5.7rem 4rem 5.1rem;
	position: relative;
	width: 100%;
	background-color: white;
	position: absolute;
	right: 0;
	box-shadow: 0px 4px 12px 5px rgba(0, 0, 0, 0.15);
	border-radius: 10px;
	z-index: 3;
`;

const CloseButton = styled.img`
	position: absolute;
	width: 14px;
	top: 2rem;
	right: 2rem;
	cursor: pointer;
`;

const PanelTitle = styled(motion.h3)`
	font-size: 1.6rem;
`;

const FlexContainer = styled(motion.div)`
	display: flex;
	align-items: center;
	gap: 3rem;
	flex-direction: column;

	@media only screen and (min-width: ${Sizes.screens.medium}) {
		flex-direction: row;
	}
`;

const ItemsWrapper = styled(FlexContainer)`
	gap: 1.5rem;

`;

const SelectFiltersButton = styled.button`
	font-size: 1.3rem;
	line-height: 1.4rem;
	padding: 1.6rem 1.8rem;
`;

const ClearFiltersButton = styled.button`
	background: none;
	padding: 0;
	height: fit-content;

	font-weight: ${Typography.fontWeight.regular};
	font-size: 1.4rem;
	line-height: 1.6rem;

	&:hover,
	&:focus {
		box-shadow: none;
		border: solid 1px blue;
	}
`;
